import {
  Box, Link, Stack, Text,
  Icon,
  TabPanels,
  TabPanel,
  Heading,
  Button,
} from '@chakra-ui/react';
import {
  Link as RLink, NavLink, useSearchParams,
} from 'react-router-dom';
import { BsFillQuestionCircleFill, BsReply } from 'react-icons/bs';
import { useEffect } from 'react';
import SidebarBox from './SidebarBox';
import SidebarField from './SidebarField';
import SideBarItem from './SideBarItem';

const EditSidebar = ({ page = 'form', name }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const type = searchParams.get('a');
  useEffect(() => {
    if (page === 'template') {
      const a = searchParams.get('a');
      searchParams.set('a', ['main', 'design'].includes(a) ? a : 'design');
      setSearchParams(searchParams);
    } else if (searchParams.get('tab') === 'setup') {
      if (!searchParams.has('a')) {
        searchParams.set('a', 'main');
        setSearchParams(searchParams);
      }
    } else if (searchParams.has('a')) {
      searchParams.delete('a');
      setSearchParams(searchParams);
    }
  }, [searchParams]);
  return (
    <SidebarBox>
      <Box display="flex" flexDir="column" justifyContent="space-between" h="100%">
        <Box color="gray.700">
          <Box mb="4" borderBottom="1px solid" borderColor="gray.300" py="1">
            <Heading as="h1" size="md" mb="2">{name}</Heading>
            <Link as={RLink} to="/forms" fontSize="sm">
              <Icon as={BsReply} mr="2" />
              Back
            </Link>
          </Box>
          <TabPanels>
            <TabPanel p="0">
              <NavLink to="../edit?tab=setup&a=main">
                {({ isActive }) => <SideBarItem name="Name" active={isActive && type === 'main'} /> }
              </NavLink>
              <NavLink to="../edit?tab=setup&a=design">
                {({ isActive }) => <SideBarItem name="Design" active={isActive && type === 'design'} /> }
              </NavLink>
              {page === 'form' && (
              <NavLink to="../edit?tab=setup&a=schedule">
                {({ isActive }) => <SideBarItem name="Schedule" active={isActive && type === 'schedule'} /> }
              </NavLink>
              )}
              {page === 'form' && (
              <NavLink to="../edit?tab=setup&a=messages">
                {({ isActive }) => <SideBarItem name="Messages" active={isActive && type === 'messages'} /> }
              </NavLink>
              )}
            </TabPanel>
            {page === 'form' && (
            <TabPanel p="0">
              <Text my="2" fontSize="sm" fontWeight="bold">Fields</Text>
              <Stack direction="column" mb="40px">
                <SidebarField type="Input" text="Input" />
                <SidebarField type="Select" text="Select" />
                <SidebarField type="Textarea" text="Textarea" />
                <SidebarField type="Text" text="Text / Title" />
                <SidebarField type="Checkbox" text="Checkbox" />
                <SidebarField type="Radio" text="Radio" />
                <SidebarField type="DatePicker" text="Date" />
              </Stack>
            </TabPanel>
            )}
          </TabPanels>
        </Box>
        <Button
          leftIcon={<Icon as={BsFillQuestionCircleFill} />}
          variant="ghost"
          size="sm"
          color="gray.400"
          as={RLink}
          to="/help"
          w="100%"
          justifyContent="flex-start"
        >
          Help
        </Button>
      </Box>
    </SidebarBox>
  );
};

export default EditSidebar;
